// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  // apiKey: "AIzaSyCzSOrnoXrkv826FwO62uQnaoSi7Usdsuw",
  // authDomain: "latihan-e056a.firebaseapp.com",
  // projectId: "latihan-e056a",
  // storageBucket: "latihan-e056a.appspot.com",
  // messagingSenderId: "981118952124",
  // appId: "1:981118952124:web:90054fa9c4f89d3184a6b9",
  // apiKey: "AIzaSyB6ICFkqOwrQPwWXuwpjEQO-xDG0z2VZsM",
  // authDomain: "to-do-list-affda.firebaseapp.com",
  // databaseURL: "https://to-do-list-affda-default-rtdb.firebaseio.com",
  // projectId: "to-do-list-affda",
  // storageBucket: "to-do-list-affda.appspot.com",
  // messagingSenderId: "189099468417",
  // appId: "1:189099468417:web:109de91bcfab3ca0f1cf80"
  apiKey: "AIzaSyD_2nQ0KCOeQjWsWSZYp1u77tZvd93Q-fY",
  authDomain: "todolist-92191.firebaseapp.com",
  projectId: "todolist-92191",
  storageBucket: "todolist-92191.appspot.com",
  messagingSenderId: "259089648414",
  appId: "1:259089648414:web:c228e7a2e4fadf7d79d70f",
  measurementId: "G-JYVQLECXLE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;
